"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.artifactType = exports.IntermediateRecordConfigSchema = exports.nodeType = exports.UIConfigSchema = void 0;
const zod_1 = require("zod");
// every node must export UIConfig.
// this type describes the configuration
// for the node as seen on tape-builder UI.
// there must also be a json schema associated with it.
exports.UIConfigSchema = zod_1.z.object({
    artifactSlug: zod_1.z.string().describe('Artifact slug'),
    creditFacilitySlug: zod_1.z
        .string()
        .describe('Must match slug, if defined, in parent generatedLoanTape'),
    generatedFilterField: zod_1.z
        .string()
        .describe('Specifies the field in the sanitized tape that will be used to determine receivables that should be included in the covenant loan tape'),
    generatedFilterValue: zod_1.z
        .string()
        .describe('Specifies the value for generatedFilterField that will trigger filtering into the covenant loan tape'),
});
exports.nodeType = 'file_generatedCovenantLoanTape';
// every tape node must also export IntermediateRecordConfig.
// this type describes the configuration for the IntermediateRecord
// (type generated by converting UI Tape + Operation Node config ).
// this includes the config for the preceding operation + config for the Tape
// + any synthetic/generated config that is needed for the corresponding task.
// - any fields that are not part of config but are part of top level record.
exports.IntermediateRecordConfigSchema = zod_1.z.object({
    generatedFilterField: zod_1.z.string(),
    generatedFilterValue: zod_1.z.string(),
});
// every tape node must also export IntermediateRecord.
// it describes the record that will be inserted into the database. (well not completely,
// because it may be modified by synthetic node creation later)
// it includes IntermediateRecordConfig + top level field like type, externalFilename, loanProductSlug, creditFacilitySlug etc.
exports.artifactType = 'generatedCovenantLoanTape';
//# sourceMappingURL=types.js.map